export default __webpack_public_path__ + "static/media/parkingrampe2.ce85fd78.png";